import AppSettings from '../AppSettings';

import {hasSomeParentTheClass} from '../../core/utils';

export default class DataCaptureHelper {

	constructor(parentElement, dataCaptureItems, templateMessages, opts = {}) {

		this.dataCaptureItems = dataCaptureItems;
		this.dcContainer = parentElement;
		this.dcElements = [];
		const _hideInitialValidationContent = opts.hideInitialValidationContent || false;
		const passthrough = [];

		const format = function () {
			let s = arguments[0];
			if (s != null && (typeof s != 'undefined')) {
				for (let i = 0; i < arguments.length - 1; i++) {
					let reg = new RegExp("\\{" + i + "\\}", "gm");
					s = s.replace(reg, arguments[i + 1]);
				}
			}

			return s;
		};


		function _getPassthroughField(name) {

			if (typeof passthrough !== 'undefined') {

				return (name.toLowerCase() in passthrough) ? passthrough[name.toLowerCase()] : "";

			} else {

				return "";
			}
		}

		const createDropDown = function (data) {

			const dropdown = document.createElement('select');
			dropdown.classList.add('ssg-dropdown', 'input-transition-effect', 'has-content');
			if (data.index) {
				dropdown.setAttribute("tabindex", data.index);
			}

			if (data.Value != null) {
				dropdown.classList.add('has-content');
			}

			dropdown.validationMessages = {};

			for (let i = 0; i < data.Options.length; i++) {
				const opt = _makeOptionDomElement(data.Options[i]);
				dropdown.appendChild(opt);
			}

			const pass = _getPassthroughField(data.Key);

			if (pass != "") {

				dropdown.validPassthrough = false;

				for (let i = 0; i < dropdown.options.length; i++) {

					if (dropdown.options[i].value === pass) {
						dropdown.selectedIndex = i;
						dropdown.validPassthrough = true;
						break;
					}
				}
			}

			dropdown.getValue = _getSelected;
			if(inlineLabel) dropdown.isValid = _hasPositiveValue; //don't need this unless dropdown label one of the dropdown options.
			dropdown.validationMessages.invalid  = format(templateMessages.dropdown.invalid, data.Label); // "Please complete the field '"+ data.Label+ "'.";
			
			return dropdown;
		};

		const createCheckBox = function (data) {
			const checkbox = document.createElement('input');
			checkbox.type = "checkbox";
			checkbox.classList.add('input-transition-effect', 'input-checkbox');
			checkbox.validationMessages = {};

			if (data.index) {
				checkbox.setAttribute("tabindex", data.index);
			}

			const def = data.Default !== "" ? data.Default : "";
			const pass = _getPassthroughField(data.Key);
			const val = pass !== "" ? pass : def;

			if (val === "true") {
				checkbox.checked = true;
				checkbox.validPassthrough = true;
			}
			else if (val !== "false") {
				checkbox.validPassthrough = false;
			}

			checkbox.isValid = function () { return !this.mandatory || (this.checked && this.mandatory); };
			checkbox.getValue = _getCheckedString;
			checkbox.validationMessages.invalid = checkbox.validationMessages.mandatory = templateMessages.checkbox.invalid; // "Please tick the check box"

			return checkbox;
		};

		const _createTextField = function (data) {
			const inputfield = document.createElement('input');
			const hasLengthCap = data.Length != null && data.Length !== 0;
			const def = data.Default !== "" ? data.Default : "";
			const pass = _getPassthroughField(data.Key);
			const val = pass !== "" ? pass : def;

			inputfield.validPassthrough = pass !== "";

			inputfield.classList.add('textbox1', 'input-transition-effect');
			if(val != '') {
				inputfield.classList.add('has-content');
			}

			inputfield.validationMessages = {};
			if (data.index) {
				inputfield.setAttribute("tabindex", data.index);
			}

			inputfield.type = "text";

			switch (data.Type) {

				case "Numeric":
					inputfield.onkeydown = _numericOnly;
					inputfield.onpaste = _preventDefault;
					inputfield.value = val;
					inputfield.isValid = _numericRegExp;
					inputfield.validationMessages.invalid = format(templateMessages.regexp.numericOnly, data.Label); // "The field '"+ data.Label +"' is numeric only."
					inputfield.type = "number";
					break;
				case "RegExp":
					const validationMessage = templateMessages.regexp.custom ? templateMessages.regexp.custom[data.Key] : templateMessages.regexp.invalid;
					inputfield.value = pass;
					inputfield.regexp = def; // regex is always this default val because its hacking the system a little
					inputfield.isValid = _regexOnly;
					inputfield.onpaste = _preventDefault;
					inputfield.validationMessages.invalid = format(validationMessage, data.Label); // "The field '"+ data.Label +"' is not valid."
					break;
				default:
					inputfield.value = val;
			}


			if (hasLengthCap) {
				inputfield.maxLength = data.Length;
				inputfield.validationMessages.length = format(templateMessages.input.length, data.Label, data.Length); //"The field '"+ data.Label +"' must be exactly "+ data.Length +" characters long.";
			}


			inputfield.getValue = _hasTextValue;
			inputfield.validationMessages.mandatory = format(templateMessages.mandatory, data.Label); // "Please complete the field '"+ data.Label+ "'.";


			return inputfield;
		};

		function _numericOnly(e) {
			// backspace, delete, tab, escape, enter and .
			if([46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
				// Ctrl+A
				(e.keyCode == 65 && e.ctrlKey === true) ||
				// home, end, left, right
				(e.keyCode >= 35 && e.keyCode <= 39)) {

				return;
			}
			// Ensure that it is a number and stop the keypress
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		}

		function _convertToMax(length) {
			return (Math.pow(10, length) - 1);
		}

		function _preventDefault(e) {
			e.preventDefault();
		}

		function _getSelected(e) {
			const select = this;
			return select.options[select.selectedIndex] ? select.options[select.selectedIndex].value : null;
		}

		function _hasPositiveValue(e) {
			const select = this;
			return select.options[select.selectedIndex].value > 0 ? true : false;
		}

		function _getCheckedString(e) {

			return this.checked ? "True" : "False";
		}

		function _hasTextValue(e) {

			return this.value;
		}

		function _numericRegExp(e) {
			const reg = new RegExp('^[0-9]+$');
			return reg.test(this.value);
		}

		function _regexOnly(e) {
			const reg = new RegExp(this.regexp, "i");
			return reg.test(this.value);
		}

		function _createLabel(object) {
			const _name = parseLink(object.Label);
			
			const label = document.createElement('label');
			label.setAttribute('for', object.Key);

			if(object.Type.toLowerCase() != 'checkbox') {
				label.innerHTML = _name;
			}
			
			return label;
		}

		function parseLink(str) {

			const link = str.indexOf("[link]");
			let aTag = str;
			let labelStr = str;

			if (link >= 0) {

				const link2 = str.indexOf("[link]", link + 6);
				const pipe = str.indexOf("|");

				if (pipe > 0) {
					aTag = "<a target='_blank' href='" + str.slice(pipe + 1, link2) + "' >" + str.slice(link + 6, pipe) + "</a>";
				}

				labelStr = str.slice(0, link) + aTag + str.slice(link2 + 6);
			}

			return labelStr;

		}

		function _createValidationDiv(object) {

			const divValidation = document.createElement('div');
			divValidation.className = "validation";

			if (!_hideInitialValidationContent) {
				divValidation.innerHTML = (object.Mandatory) ? "*" : "";
			}

			return divValidation;
		}

        function _createValidationMsgDiv() {

			const divValidationMsg = document.createElement('div');
			divValidationMsg.className = "msg-div";

			return divValidationMsg;
		}

		const _createElement = (object) => {
			let element;

			switch (object.Type) {

				case "DropDown":
					element = createDropDown(object);
					break;
				case "CheckBox":
					element = createCheckBox(object);
					break;
				default:
					element = _createTextField(object);
					break;
			}

			if (!object.AllowUserEdit && element.validPassthrough) {
				element.disabled = true;
				if (object.Type === "DropDown") {
					element.classList.add("disabledDD");
					element.childNodes[0].disabled = true;
				}
			}

			if (object.Mandatory)
				element.mandatory = true;

			element.setAttribute("id", object.Key);
			element.classList.add("dcElement");
			element.label = object.Label;
			element.returnOnHandback = object.HandbackValue;

			// store incase we dont actually want to render on the page
			this.dcElements.push(element);

			return element;
		}

		function _makeOptionDomElement(option) {
			const el = document.createElement('option');
			el.innerHTML = option.Key;
			el.value = option.Value;

			if (option.Default)
				el.selected = true;
			return el;
		}

		function _createDivFieldset(object) {

			const wrapperDiv = document.createElement('div');
			wrapperDiv.classList.add('data-capture-item', 'form-group');

			if(object.Type.toLowerCase() === 'checkbox') { //different html structure for custom checkbox
				// wrapper div for custom checkbox
				const chkboxDiv = document.createElement('div');
				chkboxDiv.className = 'checkbox';

				const label = _createLabel(object);
				label.appendChild(_createElement(object));

				// creating custom checkbox
				const customchkbox = '<span class="checkbox-material"><span class="check"></span></span>';
				const data_span = document.createElement('span');
				data_span.className = 'data';
				data_span.innerHTML = object.Label;

				label.insertAdjacentHTML( 'beforeend', customchkbox );
				label.appendChild(data_span);

				if(object.Default.toLowerCase() === 'true') { //For pre-checked checkbox
					label.querySelector('.check').classList.add('borderCol_1');
				}
				
				chkboxDiv.appendChild(label);
				wrapperDiv.appendChild(chkboxDiv);
			}
			else {
				wrapperDiv.appendChild(_createElement(object));
				wrapperDiv.appendChild(_createLabel(object));
			}
			
			wrapperDiv.appendChild(_createValidationDiv(object));
			wrapperDiv.appendChild(_createValidationMsgDiv());

			return wrapperDiv;
		}


		//entry point
		const visibleFields = dataCaptureItems.filter(item => item.Display);
		this.hiddenFields = dataCaptureItems.filter(item => item.HandbackValue).map(item => {
			const pass = _getPassthroughField(item.Key);
			if (pass !== "") item.Default = pass;
			return item;
		});


		for (const field of visibleFields) {
			this.dcContainer.appendChild(_createDivFieldset(field));
		}


	}

	getValues(isPassthrough) {

		const values = {};

		const elementCollection = this.dcElements;

		for (let i = 0; i < elementCollection.length; i++) {

			const el = elementCollection[i];

			const val = el.getValue();

			const flag = isPassthrough ? el.returnOnHandback : true;

			if (flag) {

				values[el.getAttribute("id")] = val;
			}
		}

		for (let i = 0; i < this.hiddenFields.length; i++) {

			// regexp cant have a default value because of the dumb hack
			values[this.hiddenFields[i].Key] = this.hiddenFields[i].Type === 'RegExp' ? '' : this.hiddenFields[i].Default;
		}

		/* Assigning values to main object which gets used in final card submission */
		if (AppSettings.client.CustomDataCapture) {
			for (const captureItem of AppSettings.client.CustomDataCapture) {
				const key = captureItem.Key;
				captureItem.Value = values[key];
			}
		}

		return values;
	};

	getValidations(e) {
		const el = e ? e.currentTarget : undefined;
		return this.validateFields(el);
	};

	validateFields(el) {
		const activeInput = el;
		const elementCollection = this.dcElements;
		let messages = [];
		let j = 0;

	 	// On focusout event on input
		if(activeInput != undefined) {
			for (let i = 0; i < elementCollection.length; i++){
				if(elementCollection[i] === activeInput) {
					messages = this.getValidationtMessages(activeInput, messages, j);
					j++;
					break;
				}
			}
		}
		
		// On click of submit button
		else {
			this.removeAllValidations();
			for (let i = 0; i < elementCollection.length; i++){
				let el = elementCollection[i];
				messages = this.getValidationtMessages(el, messages, j);
				j++;
			}
		}

		return messages;
	};

	getValidationtMessages(el, messages, j) {
		if (!el.disabled) {
			
			// CASE 1: input is empty
			if (el.mandatory && el.getValue() === ""){
				messages[j] = el.validationMessages.mandatory;
			}

			// CASE 2: input value is not within the length
			else if (el.getValue() !== "" && el.maxlength != null && el.value.length < el.maxlength){
				messages[j] = el.validationMessages.length;
			}
			
			// CASE 3: input is not valid
			else if (el.getValue() !== "" && el.isValid != null && !el.isValid()){
				messages[j] = el.validationMessages.invalid;
			}
			
			this.performValidations_UI(el, messages[j]);

			return messages;
		}
	}

	performValidations_UI(el, message) {
		const field_item = hasSomeParentTheClass(el, 'form-group');
		
		/* class toggle for Floating Label UI */
		if(el.getValue() === '') {
			el.classList.remove("has-content");
		}
		else {
			el.classList.add("has-content");
		}

		if(message === undefined || message === '') {
			field_item.classList.remove('error-input-wrap');
			field_item.querySelector('.msg-div').innerHTML = '';
		}
		else {
			field_item.querySelector('.msg-div').innerHTML = message;
			field_item.classList.add('error-input-wrap');
		}
	}

	removeAllValidations() {
		const field_msg = this.dcContainer.querySelectorAll(".msg-div");
		[].forEach.call(field_msg, function(el) {
			el.innerHTML = "";
		});

		const field_item = this.dcContainer.querySelectorAll(".form-group");
		[].forEach.call(field_item, function(el) {
			el.classList.remove('error-input-wrap');
		});
	};
	
}
